import { render, staticRenderFns } from "./CtrlItakusaki.vue?vue&type=template&id=14080948&"
import script from "./CtrlItakusaki.vue?vue&type=script&lang=ts&"
export * from "./CtrlItakusaki.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports